export enum ProfileTabLabel {
	GENERAL = 'Settings',
	NOTIFICATIONS = 'Notifications',
	BILLING = 'Billing',
	CONTRIBUTIONS = 'Contributions',
	TEAM = 'Team',
	CONTACTS = 'Contacts',
	INTEGRATIONS = 'Integrations',
}
